export default __webpack_public_path__ + "static/media/productIcon1.cb294565.svg";